import { attachDesktopMouseDrag, getHorizontalStep, updateHorizontalNavState } from "../../utilities/scroller-utils";

const initManualReviewsContainer = (scroller) => {
  if (!scroller || scroller.dataset.manualReviewsInitialized === "true") return;

  const section = scroller.closest("[data-manual-reviews-id]");
  const isHealthExpertsSection = section
    ? section.classList.contains("manual-reviews-section--health-experts")
    : false;
  const imageScroller = section ? section.querySelector("[data-manual-reviews-images-scroller]") : null;
  const prevButton = section ? section.querySelector("[data-manual-reviews-prev]") : null;
  const nextButton = section ? section.querySelector("[data-manual-reviews-next]") : null;
  const items = Array.from(scroller.querySelectorAll(".manual-review"));

  if (!items.length) return;

  scroller.dataset.manualReviewsInitialized = "true";

  let resizeTimer = null;
  let scrollEndTimer = null;

  const getStep = () => getHorizontalStep(scroller, items[0]);

  const updateNavState = () => updateHorizontalNavState(scroller, prevButton, nextButton);

  const equalizeContainerHeights = () => {
    const textElements = items
      .map((item) => item.querySelector(".review-text"))
      .filter(Boolean);
    const contentElements = items
      .map((item) => item.querySelector(".review-content"))
      .filter(Boolean);

    if (!textElements.length && !contentElements.length) return;

    textElements.forEach((textElement) => {
      textElement.style.minHeight = "";
    });
    contentElements.forEach((contentElement) => {
      contentElement.style.minHeight = "";
    });

    let tallestHeight = 0;
    textElements.forEach((textElement) => {
      tallestHeight = Math.max(tallestHeight, textElement.getBoundingClientRect().height);
    });

    if (tallestHeight > 0) {
      const targetTextHeight = `${Math.ceil(tallestHeight)}px`;
      textElements.forEach((textElement) => {
        textElement.style.minHeight = targetTextHeight;
      });
    }

    if (isHealthExpertsSection && contentElements.length) {
      let tallestContentHeight = 0;
      contentElements.forEach((contentElement) => {
        tallestContentHeight = Math.max(tallestContentHeight, contentElement.getBoundingClientRect().height);
      });

      if (tallestContentHeight > 0) {
        const targetContentHeight = `${Math.ceil(tallestContentHeight)}px`;
        contentElements.forEach((contentElement) => {
          contentElement.style.minHeight = targetContentHeight;
        });
      }
    }
  };

  const scrollByStep = (direction) => {
    const step = getStep() * direction;

    scroller.scrollBy({
      left: step,
      behavior: "smooth",
    });

    if (imageScroller) {
      imageScroller.scrollBy({
        left: step,
        behavior: "smooth",
      });
    }
  };

  const handleScroll = () => {
    updateNavState();
    window.clearTimeout(scrollEndTimer);
    scrollEndTimer = window.setTimeout(() => {
      equalizeContainerHeights();
    }, 120);
  };

  const handleResize = () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => {
      updateNavState();
      equalizeContainerHeights();
    }, 120);
  };

  if (prevButton && nextButton) {
    prevButton.addEventListener("click", () => scrollByStep(-1));
    nextButton.addEventListener("click", () => scrollByStep(1));
  }

  if (isHealthExpertsSection) {
    attachDesktopMouseDrag(scroller, { imageSelector: ".manual-review img" });
  }

  scroller.addEventListener("scroll", handleScroll, { passive: true });
  window.addEventListener("resize", handleResize);

  updateNavState();
  equalizeContainerHeights();
  window.setTimeout(equalizeContainerHeights, 0);
};

const initManualReviews = (root = document) => {
  if (!root) return;

  if (root.matches && root.matches("[data-manual-reviews-scroller]")) {
    initManualReviewsContainer(root);
  }

  if (root.querySelectorAll) {
    root.querySelectorAll("[data-manual-reviews-scroller]").forEach(initManualReviewsContainer);
  }
};

export { initManualReviews };
